import _ from "lodash"
import { getLanguages } from 'api/functions/functions';
import MainContext from 'context/MainContext';
import { useEffect, useContext, useState } from 'react';
import { Select, SelectItem, SelectSkeleton } from "carbon-components-react";
import classnames from "classnames";

function useMultilangForm({ modal, ...props }) {

    const context = useContext(MainContext)
    const [languages, setLanguages] = useState([])
    const [selectedLangCode, setSelectedLangCode] = useState("en")

    useEffect(() => {
        async function fetchData() {
            const data = await getLanguages();
            const langs = data.filter(l => {
                return context.evt.languages.includes(l.id)
            })
            setLanguages(langs)
        }
        fetchData()
    }, [])

    useEffect(() => {
        if (_.isEmpty(languages)) {
            return false
        }
        // setSelectedLang("en")default_lang
        setSelectedLangCode(_.get(context, "evt.default_lang"))
    }, [languages])

    const onlanguagechange = (e) => {
        try {
            const langCode = e.target.value
            // setSelectedLang(e.target.value)
            setSelectedLangCode(langCode)
            if (props.onLangChanged) {
                props.onLangChanged(langCode)
            }
        }
        catch (e) { }
    }

    const reset = () => {
        setSelectedLangCode(_.get(context, "evt.default_lang"))
    }

    const defaultParams = {
        lang_id: selectedLangCode
    }

    const languageSelect = (
        languages && selectedLangCode ? (
            <div className={classnames({
                "bx--modal-content": modal
            })}
                style={{
                    marginBottom: "2rem"
                }}>
                <Select
                    labelText={_.get(props, "label", "Select")}
                    defaultValue={{
                        id: selectedLangCode
                    }} onChange={(e) => onlanguagechange(e)}>
                    {
                        !_.isEmpty(languages) ? languages.map(item => {
                            return (
                                <SelectItem
                                    text={item.label}
                                    value={item.id}
                                    selected={selectedLangCode === item.id}
                                />
                            )
                        }) : (
                            <SelectSkeleton />
                        )
                    }
                </Select>
            </div>
        ) : null
    )


    return {
        _reset: reset,
        _selectedLangCode: selectedLangCode,
        _defaultParams: defaultParams,
        _languageSelect: languageSelect,
    };
}

export default useMultilangForm